import type { ChartConfig } from '../../ui/chart';

export const PLATFORMS = ['YouTube', 'Instagram', 'TikTok', 'Twitter/X'];

export const CHANNEL_WIZARD_STEPS = [
  { num: 1, title: 'Channel URL', sub: 'YouTube channel to scan' },
  { num: 2, title: 'Brand policies', sub: 'Keywords & sensitive topics' },
  { num: 3, title: 'Targets & run', sub: 'Platforms & start analysis' },
];
export const NEWS_WIZARD_STEPS = [{ num: 1, title: 'News search', sub: 'Creator or channel name' }];
export const BRAND_SAFETY_CACHE_PREFIX = 'discovr:brand-safety:v4:';
export const BRAND_SAFETY_NEWS_CACHE_PREFIX = 'discovr:brand-safety:news:';
export const BRAND_SAFETY_CACHE_TTL_MS = 1000 * 60 * 60 * 6; // 6 hours

export const RISK_COLORS: Record<string, { text: string; bg: string; border: string }> = {
  Safe:         { text: '#15803d', bg: '#f0fdf4', border: '#bbf7d0' },
  safe:         { text: '#15803d', bg: '#f0fdf4', border: '#bbf7d0' },
  Moderate:     { text: '#b45309', bg: '#fffbeb', border: '#fde68a' },
  moderate:     { text: '#b45309', bg: '#fffbeb', border: '#fde68a' },
  Risky:        { text: '#b91c1c', bg: '#fef2f2', border: '#fecaca' },
  risky:        { text: '#b91c1c', bg: '#fef2f2', border: '#fecaca' },
  Blocked:      { text: '#7c3aed', bg: '#f5f3ff', border: '#ddd6fe' },
  blocked:      { text: '#7c3aed', bg: '#f5f3ff', border: '#ddd6fe' },
  'Needs Review': { text: '#92400e', bg: '#fef3c7', border: '#fcd34d' },
  needs_review:   { text: '#92400e', bg: '#fef3c7', border: '#fcd34d' },
};
export const RC = (flag: string) =>
  RISK_COLORS[flag] || { text: '#475569', bg: '#f8fafc', border: '#e2e8f0' };
// Fills from the actual composed "Channel Analysis" instance (App file,
// node 1672:32976) — not an isolated component variant. Only `toxic` was
// ever wrong: it duplicated `positive`'s purple instead of using its own
// red, so the two were indistinguishable in the chart/legend.
export const SC = { positive: '#6C09F7', neutral: '#DA58FE', negative: '#FDBA74', toxic: '#EF4444' };

export const safetyChartConfig: ChartConfig = {
  value:            { label: 'Value',            color: '#6366F1' },
  Positive:         { label: 'Positive',         color: '#10B981' },
  Neutral:          { label: 'Neutral',          color: '#0EA5E9' },
  Negative:         { label: 'Negative',         color: '#F59E0B' },
  Toxic:            { label: 'Toxic',            color: '#8B5CF6' },
  commentSafety:    { label: 'Comment Safety',   color: '#6C09F7' },
  transcriptSafety: { label: 'Transcript Safety',color: '#F37AED' },
};

export const DEFAULT_BANNED_KEYWORDS: string[] = [
  // Profanity & Abuse
  'fuck',
  'shit',
  'bitch',
  'bastard',
  'asshole',
  'mf',
  'bs',
  'chutiya',
  'madarchod',
  'bc',
  'mc',
  // Sexual / Adult
  'porn',
  'nudes',
  'blowjob',
  'onlyfans',
  'escort',
  'sexvideo',
  // Violence & Threats
  'kill',
  'murder',
  'rape',
  'bomb',
  'shoot',
  'attack',
  "i'll kill you",
  'they should die',
  // Drugs / Illegal
  'cocaine',
  'heroin',
  'weed',
  'mdma',
  'lsd',
  'drug dealing',
  // Scam / Fraud / Misleading
  'scam',
  'fraud',
  'ponzi',
  'phishing',
  'fake giveaway',
  'guaranteed returns',
  'double your money',
  // Brand Risk / Reputation
  'boycott',
  'cancel',
  'exposed',
  'controversy',
  'this brand is fake',
  "don't trust them",
];

export const DEFAULT_SENSITIVE_TOPICS: string[] = [
  // Politics
  'politics',
  'elections',
  'government',
  'political party',
  // Religion
  'religion',
  'god',
  'religious insult',
  // Mental Health
  'suicide',
  'depression',
  'anxiety',
  'self harm',
  // Gender & Sexuality
  'LGBTQ+',
  'feminism',
  'gender identity',
  // Violence / Tragedy
  'terrorism',
  'war',
  'tragedy',
  'accident',
  // Financial Claims
  'guaranteed profit',
  'no loss',
  'financial advice',
  'investment returns',
  // Health / Medical
  'fake cure',
  'health misinformation',
  'unverified treatment',
  // Body Image
  'fat shaming',
  'body shaming',
  'skin tone discrimination',
  // Legal / Criminal
  'arrests',
  'lawsuits',
  'criminal activity',
];
